import { Directive } from '@angular/core';

@Directive({
  selector: '[appWizardStep]'
})
export class WizardStepDirective {}
